import bigCustClueReport from './bigCustClueReport'
export default bigCustClueReport
